import React, {
  Dispatch,
  MouseEventHandler,
  SetStateAction,
  useState,
} from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import { ErrorMessage, withFormik } from 'formik'
import type { FormikProps } from 'formik'
import * as Yup from 'yup'
import { LoginFormValues } from '../../store/userSlice'
import { useAppDispatch, useAppSelector } from '../../store'
import { ApiResult, LoadingStatus } from '../../models/Enums'
import { useDispatch } from 'react-redux'
import WaitAnimation from '../Common/Wait'
import { Button } from '@mui/material'
import axios from 'axios'

interface OtherProps {
  setOpen: Dispatch<SetStateAction<boolean>>
}

interface MyFormProps {
  initialUserid?: string
  initialPassword?: string
  onLogin: (values: LoginFormValues) => void
}

const InnerForm = (props: FormikProps<LoginFormValues>) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = props

  const loginStatus = useAppSelector((state) => state.user.loginStatus)
  const apiResult = useAppSelector((state) => state.user.apiResult)

  // const kakaoLogin = async () => {
  //   Kakao.Auth.authorize({
  //     redirectUri: KAKAO_REDIRECT_URL,
  //     scope: 'profile_nickname, name, account_email',
  //   })
  // }

  return (
    <Container>
      <h1>로그인</h1>
      <form onSubmit={handleSubmit}>
        <input
          width={50}
          type="text"
          name="userid"
          placeholder="사용자 아이디"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.userid}
        />
        {touched.userid && errors.userid ? (
          <LoginErrorMessage>{errors.userid}</LoginErrorMessage>
        ) : null}
        <input
          width={50}
          type="password"
          name="password"
          placeholder="비밀번호"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
        />
        {touched.password && errors.password ? (
          <LoginErrorMessage>{errors.password}</LoginErrorMessage>
        ) : null}
        <button
          type="submit"
          disabled={
            isSubmitting ||
            !!(errors.userid && touched.userid) ||
            !!(errors.password && touched.password)
          }
        >
          {loginStatus == LoadingStatus.PENDING && (
            <WaitAnimation left="100px" top="4px" />
          )}
          로그인
        </button>
        {apiResult === ApiResult.NOT_EXIST && (
          <LoginErrorMessage>잘못된 아이디나 비밀번호입니다</LoginErrorMessage>
        )}
        {apiResult === ApiResult.UNKNOWN_ERROR && (
          <LoginErrorMessage>서버에 연결할 수 없습니다</LoginErrorMessage>
        )}
      </form>
    </Container>
  )
}

const LoginForm = withFormik<MyFormProps, LoginFormValues>({
  mapPropsToValues: (props) => ({
    userid: props.initialUserid || '',
    password: props.initialPassword || '',
  }),

  validationSchema: Yup.object().shape({
    userid: Yup.string().required('사용자 아이디를 입력하세요'),
    password: Yup.string().required('비밀번호를 입력하세요'),
  }),

  handleSubmit(
    values: LoginFormValues,
    { props, setSubmitting, setErrors, submitForm }
  ) {
    props.onLogin(values)
    setSubmitting(false)
  },
})(InnerForm)

const Container = styled.div`
  width: 20rem;

  h1 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    text-align: center;
    color: #666;
  }

  input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border: 1px solid #ccc;
  }

  button {
    width: 100%;
    padding: 12px;
    margin-top: 10px;
    border: none;
    background-color: orange;
    position: relative;
  }
`
const LoginErrorMessage = styled.div`
  color: #d05555;
`

export default LoginForm
